export const IconArrow = ({ type = '', className }: { className?: string; type?: any }) => (
  <svg className={`transform fill-current ${className} ${type}`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0002 15.4999C11.7344 15.5015 11.4789 15.3971 11.2902 15.2099L7.29019 11.2099C6.89806 10.8178 6.89806 10.1821 7.29019 9.78994C7.68231 9.39782 8.31807 9.39782 8.71019 9.78994L12.0002 13.0999L15.3002 9.91994V9.91994C15.6695 9.50929 16.3018 9.47578 16.7124 9.84508C17.1231 10.2144 17.1566 10.8467 16.7873 11.2573C16.7542 11.2941 16.7184 11.3284 16.6802 11.3599L12.6802 15.2199C12.4973 15.3963 12.2542 15.4964 12.0002 15.4999L12.0002 15.4999Z"
    />
  </svg>
)
